import axios from 'axios';
import ItemUnavailableError from '@root/lib/errors/ItemUnavailableError';

/**
 * Gets the cart
 */
const getCart = async () => {
  const resp = await axios.get('/cart.js');
  return resp.data;
}

/**
 * Adds items to the cart
 * 
 * @param  {...{
 *   id: number;
 *   quantity?: number;
 *   properties?: Object;
 * }} items 
 */
const addItems = async (...items) => {
  try {
    const resp = await axios.post('/cart/add.js', {items});
    return resp.data.items;
  } catch (e) {
    /** @type {string} */
    const error = e?.response?.data?.description;

    if (error?.startsWith?.('You can\'t add more')) {
      const [ ,title ] = error.match(/^You can't add more (.+) to the cart.$/);
      throw new ItemUnavailableError(title);
    } else if (error?.startsWith?.('The product \'')) {
      const [ ,title ] = error.match(/^The product '(.+)' is already sold out.$/);
      throw new ItemUnavailableError(title);
    }

    throw e;
  }
}

/**
 * Clears the cart of all it's items. Attributes will be preserved
 * 
 * @param {Boolean} hardClear if true will discard the old cart token
 */
const clear = async (hardClear = false) => {
  if (hardClear) {
    document.cookie = 'cart=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    return;
  }

  const resp = await axios.post('/cart/clear.js');
  return resp.data;
}

/**
 * Adds attributes to the cart
 * 
 * @param {Map<string, any>} attributes 
 */
const addAttributes = async (attributes) => {
  const resp = await axios.post('/cart/update.js', {attributes});
  return resp.data;
}

export {
  getCart,
  addItems,
  clear,
  addAttributes,
}